import axios from "axios";
import { API_URL, token } from "../../Config/AppConstant";

const initialState = {
  loading: false,
  serviceCategories: [], // Stores service categories
  error: null,
  deleteLoading: false,
  editLoading: false,
  addLoading: false,
  pagination: {}, // Stores pagination information
};

// Action types
const FETCH_SERVICE_CATEGORIES_REQUEST = "FETCH_SERVICE_CATEGORIES_REQUEST";
const FETCH_SERVICE_CATEGORIES_SUCCESS = "FETCH_SERVICE_CATEGORIES_SUCCESS";
const FETCH_SERVICE_CATEGORIES_FAILURE = "FETCH_SERVICE_CATEGORIES_FAILURE";
const DELETE_SERVICE_CATEGORY_REQUEST = "DELETE_SERVICE_CATEGORY_REQUEST";
const DELETE_SERVICE_CATEGORY_SUCCESS = "DELETE_SERVICE_CATEGORY_SUCCESS";
const DELETE_SERVICE_CATEGORY_FAILURE = "DELETE_SERVICE_CATEGORY_FAILURE";
const EDIT_SERVICE_CATEGORY_REQUEST = "EDIT_SERVICE_CATEGORY_REQUEST";
const EDIT_SERVICE_CATEGORY_SUCCESS = "EDIT_SERVICE_CATEGORY_SUCCESS";
const EDIT_SERVICE_CATEGORY_FAILURE = "EDIT_SERVICE_CATEGORY_FAILURE";
const ADD_SERVICE_CATEGORY_REQUEST = "ADD_SERVICE_CATEGORY_REQUEST";
const ADD_SERVICE_CATEGORY_SUCCESS = "ADD_SERVICE_CATEGORY_SUCCESS";
const ADD_SERVICE_CATEGORY_FAILURE = "ADD_SERVICE_CATEGORY_FAILURE";

// Fetch categories
export const fetchServiceCategories = (page = 1, limit = 10) => async (dispatch) => {
  dispatch({ type: FETCH_SERVICE_CATEGORIES_REQUEST });
  try {
    const { data } = await axios.get(`${API_URL}/serviceCategory?page=${page}&limit=${limit}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: FETCH_SERVICE_CATEGORIES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_SERVICE_CATEGORIES_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch categories",
    });
  }
};

// Delete category
export const deleteServiceCategory = (id) => async (dispatch) => {
  dispatch({ type: DELETE_SERVICE_CATEGORY_REQUEST });
  try {
    await axios.delete(`${API_URL}/serviceCategory/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: DELETE_SERVICE_CATEGORY_SUCCESS, payload: id });
  } catch (error) {
    console.log("err", error);
    dispatch({
      type: DELETE_SERVICE_CATEGORY_FAILURE,
      payload: error.response?.data?.message || "Failed to delete category",
    });
  }
};

// Edit category
export const editServiceCategory = (id, updatedData) => async (dispatch) => {
  dispatch({ type: EDIT_SERVICE_CATEGORY_REQUEST });
  try {
    const { data } = await axios.patch(`${API_URL}/serviceCategory/${id}`, updatedData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: EDIT_SERVICE_CATEGORY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: EDIT_SERVICE_CATEGORY_FAILURE,
      payload: error.response?.data?.message || "Failed to edit category",
    });
  }
};

// Add category
export const addServiceCategory = (newCategory) => async (dispatch) => {
  dispatch({ type: ADD_SERVICE_CATEGORY_REQUEST });
  try {
    const { data } = await axios.post(`${API_URL}/serviceCategory`, newCategory, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: ADD_SERVICE_CATEGORY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ADD_SERVICE_CATEGORY_FAILURE,
      payload: error.response?.data?.message || "Failed to add category",
    });
  }
};

// Reducer for managing service categories
export const serviceCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch categories
    case FETCH_SERVICE_CATEGORIES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SERVICE_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceCategories: action.payload.services,
        pagination: action.payload.pagination,
        error: null,
      };
    case FETCH_SERVICE_CATEGORIES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Delete category
    case DELETE_SERVICE_CATEGORY_REQUEST:
      return { ...state, deleteLoading: true };
    case DELETE_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        serviceCategories: state.serviceCategories.filter(
          (category) => category._id !== action.payload
        ),
      };
    case DELETE_SERVICE_CATEGORY_FAILURE:
      return { ...state, deleteLoading: false, error: action.payload };

    // Edit category
    case EDIT_SERVICE_CATEGORY_REQUEST:
      return { ...state, editLoading: true };
    case EDIT_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        editLoading: false,
        serviceCategories: state.serviceCategories.map((category) =>
          category._id === action.payload._id ? action.payload : category
        ),
      };
    case EDIT_SERVICE_CATEGORY_FAILURE:
      return { ...state, editLoading: false, error: action.payload };

    // Add category
    case ADD_SERVICE_CATEGORY_REQUEST:
      return { ...state, addLoading: true };
    case ADD_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        addLoading: false,
        serviceCategories: [action.payload, ...state.serviceCategories],
      };
    case ADD_SERVICE_CATEGORY_FAILURE:
      return { ...state, addLoading: false, error: action.payload };

    default:
      return state;
  }
};
